import Header from "@/components/Header";
import AboutSection from "@/components/AboutSection";
import Services from "@/components/Services";
import Zones from "@/components/Zones";
import FAQ from "@/components/FAQ";
import CallButton from "@/components/CallButton";
import Footer from "@/components/Footer";
import SEO from "@/components/SEO";
import { useState } from "react";
import { Phone, Clock, Shield, Zap } from "lucide-react";
import { Button } from "@/components/ui/button";
import heroImage from "@/assets/serrurier-hero-new.jpg";
import { CallbackForm } from "@/components/CallbackForm";

const Lyon4 = () => {
  const [callbackOpen, setCallbackOpen] = useState(false);

  return (
    <div className="min-h-screen">
      <SEO 
        title="Serrurier Lyon 4 24h/7j – Croix-Rousse | Tolstoï Serrurier | 06 95 22 00 18"
        description="Serrurier d'urgence Lyon 4ème arrondissement : Croix-Rousse. Ouverture porte, changement/réparation serrure, volet roulant. Intervention rapide 24h/24 et 7j/7."
        keywords="serrurier Lyon 4, serrurier Croix-Rousse, dépannage serrure Lyon 4, ouverture porte Lyon 4ème, serrurier urgence Croix-Rousse"
        canonical="https://www.tolstoi-serrurier.fr/lyon-4"
        ogUrl="https://www.tolstoi-serrurier.fr/lyon-4"
        ogImage="https://www.tolstoi-serrurier.fr/logo.jpg"
      />
      <Header />
      <main>
        {/* Hero Section Lyon 4 */}
        <section className="relative text-white pt-32 pb-20 overflow-hidden">
          <div className="absolute inset-0">
            <img 
              src={heroImage} 
              alt="Serrurier professionnel Lyon 4ème arrondissement - Croix-Rousse" 
              className="w-full h-full object-cover"
            />
          </div>
          <div className="absolute inset-0 bg-black/50" />
          
          <div className="container mx-auto px-4 relative z-10">
            <div className="max-w-4xl mx-auto text-center mb-16">
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 leading-tight">
                Serrurier Lyon 4<sup>ème</sup>
              </h1>
              <p className="text-xl md:text-2xl mb-4 text-white/90">
                Croix-Rousse
              </p>
              <p className="text-lg mb-8 text-white/80">
                Intervention rapide dans tout le 4<sup>ème</sup> arrondissement. Ouverture de porte, changement et réparation de serrure 24h/7j.
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <Button size="lg" variant="default" className="text-lg px-8 py-6 gap-3" asChild>
                  <a href="tel:0695220018">
                    <Phone className="h-6 w-6" />
                    06 95 22 00 18
                  </a>
                </Button>
                <Button 
                  size="lg" 
                  variant="secondary" 
                  className="text-lg px-8 py-6 gap-3"
                  onClick={() => setCallbackOpen(true)}
                >
                  Demander un rappel
                </Button>
              </div>
            </div>

            <CallbackForm open={callbackOpen} onOpenChange={setCallbackOpen} />

            <div className="max-w-4xl mx-auto">
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                <div className="flex flex-col items-center gap-3 p-6 bg-white/10 backdrop-blur-sm rounded-xl border border-white/20">
                  <Clock className="h-10 w-10 text-primary" />
                  <h2 className="font-semibold text-lg">Intervention rapide</h2>
                  <p className="text-sm text-white/80">24h/24 et 7j/7</p>
                </div>
                <div className="flex flex-col items-center gap-3 p-6 bg-white/10 backdrop-blur-sm rounded-xl border border-white/20">
                  <Shield className="h-10 w-10 text-primary" />
                  <h2 className="font-semibold text-lg">Serrurier certifié</h2>
                  <p className="text-sm text-white/80">Professionnel qualifié</p>
                </div>
                <div className="flex flex-col items-center gap-3 p-6 bg-white/10 backdrop-blur-sm rounded-xl border border-white/20">
                  <Zap className="h-10 w-10 text-primary" />
                  <h2 className="font-semibold text-lg">Devis transparent</h2>
                  <p className="text-sm text-white/80">Sans surprise</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <AboutSection 
          location="Lyon 4ème" 
          locationContext="dans le 4ème arrondissement de Lyon (Croix-Rousse)"
        />
        <Services location="Lyon 4ème" />
        <Zones />
        <FAQ location="Lyon 4ème" />
      </main>
      <Footer />
      <CallButton />
    </div>
  );
};

export default Lyon4;
